import React, { FunctionComponent } from 'react';

import { ContactDateOfBirthStep as CommonContactDateOfBirth } from 'scenes/common/components/Steps';

import { LandlordFullPageProps } from 'scenes/landlord/types';
import {
  getPolicyHolderDateOfBirth,
  getBusinessOwnerDateOfBirth,
  isPolicyIssuedToPerson,
} from 'scenes/landlord/selectors';

const ContactDateOfBirthStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const issuedToPerson = isPolicyIssuedToPerson(funnelState);

  return (
    <CommonContactDateOfBirth
      onNext={onNext}
      isPolicyIssuedToPerson={issuedToPerson}
      defaultStateValue={
        issuedToPerson
          ? getPolicyHolderDateOfBirth(funnelState)
          : getBusinessOwnerDateOfBirth(funnelState)
      }
    />
  );
};

export default ContactDateOfBirthStep;
